import { Component } from '@angular/core';
import { FormComponentLookup } from '@ptl/forms';
import { MassUploadFormControlComponent } from '../mass-upload-form-control.component';
import { DropdownOption, EMPTY_DROPDOWN_OPTION } from '../../../../producer/mass-upload-grid/interfaces/mass-upload-grid.interface';
import { tap, debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { PlanAttributes, SummaryView } from '../../../../plan-selection/interfaces/plan-attributes.interface';
import { Product } from '../../../../plan-selection/interfaces/product.interface';
import { PlanServiceResponse } from 'src/app/angular-elements/plan-selection/interfaces/plan-service-response.interface';

@FormComponentLookup('mass-upload-grid-control-hios-id')
@Component({
  selector: 'app-mass-upload-hios-id-form-control',
  templateUrl: '../mass-upload-form-control.component.html',
  styleUrl: '../mass-upload-form-control.component.scss',
  standalone: false
})
export class MassUploadHiosIdFormControlComponent extends MassUploadFormControlComponent {
  
  ngOnInit() {
    super.ngOnInit();

    this.isDropdown = true;
    this.dropdownOptions = [];
    let effectiveDateControl = this.getEffectiveDateControl();

    this.initializePlans(effectiveDateControl.value);

    this.subscriptionGroup.push(effectiveDateControl.valueChanges.pipe(
        tap(() => {
          this.isLoading = true;
        }),
        switchMap(async (effectiveDate) => {
          return await this.loadPlans(effectiveDate);
        })
      )
      .subscribe((plansResponse) => {
        this.updatePlanOptions(plansResponse);
      }));
  }

  resetFormValue(value?: any): void {
    this.selfAsFormControl.setValue(value);
    this.entry.formControlAttributes.setDefaultValue = value;
  }

  onBlur(): void {
    this.entry.formControlAttributes.setDefaultValue = this.selfAsFormControl.value;
  }

  async initializePlans(effectiveDate: string) {
    this.isLoading = true;
    const plans = await this.loadPlans(effectiveDate);
    this.updatePlanOptions(plans);
  }

  async loadPlans(effectiveDate: string): Promise<PlanServiceResponse> {
    let zipCode = this.mugDataHelperService.getZipCodeByStateId(this.stateId);
    let county = await this.getCounty();

    if (!zipCode || !county || !effectiveDate) {
      return null;
    }

    return await this.mugService.loadIndividualPlans(zipCode, county, this.stateId);
  }

  updatePlanOptions(plansResponse: PlanServiceResponse) {
    this.isLoading = false;
    if (plansResponse?.statusCode === 200) {
      this.dropdownOptions = EMPTY_DROPDOWN_OPTION.concat(this.mugService.parsePlansAsDropdownValues(plansResponse));

      // The default value will be the HIOS ID from the raw data, not a plan object.
      let matchedPlan: DropdownOption = null;
      if (this.selfAsFormControl.value && typeof this.selfAsFormControl.value === 'string') {
        matchedPlan = this.dropdownOptions.find((opt) => {
          let plan = opt.value as Product<PlanAttributes, SummaryView>;
          return plan?.attributes?.HIOS_ID === this.selfAsFormControl.value;
        });
      }
      // Otherwise we should have a plan object that matches the exact object and reference in the dropdown options
      else {
        matchedPlan = this.dropdownOptions.find((ddOpt) => ddOpt.value === this.selfAsFormControl.value);
      }

      if (!matchedPlan) {
        this.resetFormValue(null);
      }
      else {
        // Always enforce object equality by resetting the value to the actual dropdown reference
        this.resetFormValue(matchedPlan.value);
      }
    }
    else {
      this.dropdownOptions = [];
      this.resetFormValue(null);
    }
  }
}
